module.exports = __webpack_public_path__ + "img/C06TechSlingerChampion_ua.c2bbece6.webp";